import React, { useState } from 'react';
import { chatApi } from '../../Services/chatService';

const AgentAssignModal = ({ conversationId, agents, currentAgentId, onAssigned, onClose }) => {
    const [selectedAgentId, setSelectedAgentId] = useState(currentAgentId || '');
    const [loading, setLoading]                 = useState(false);
    const [error, setError]                     = useState('');

    const handleAssign = async () => {
        if (!selectedAgentId) { setError('Please select an agent'); return; }
        try {
            setLoading(true);
            setError('');
            const { data } = await chatApi.assignAgent(conversationId, selectedAgentId);
            if (data.status === 1) {
                onAssigned(data.data);
            } else {
                setError(data.message || 'Assignment failed');
            }
        } catch (e) {
            setError(e.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-box" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Assign Support Agent</h3>
                    <button className="modal-close" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body">
                    {agents.length === 0 ? (
                        <div className="modal-empty">No support agents available</div>
                    ) : (
                        <div className="agent-list">
                            {agents.map(agent => (
                                <div
                                    key={agent._id}
                                    className={`agent-option ${selectedAgentId === agent._id ? 'agent-option--selected' : ''}`}
                                    onClick={() => setSelectedAgentId(agent._id)}
                                >
                                    <div className="agent-option-avatar">
                                        {(agent.firstname?.[0] || 'A').toUpperCase()}
                                    </div>
                                    <div className="agent-option-info">
                                        <div className="agent-option-name">
                                            {agent.firstname} {agent.lastname}
                                        </div>
                                        <div className="agent-option-email">{agent.email}</div>
                                    </div>
                                    <div className={`agent-status-dot ${agent.isOnline ? 'online' : 'offline'}`} />
                                    {selectedAgentId === agent._id && (
                                        <span className="agent-check">✓</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {error && <div className="modal-error">{error}</div>}
                </div>

                <div className="modal-footer">
                    <button className="modal-btn modal-btn--cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="modal-btn modal-btn--assign"
                        onClick={handleAssign}
                        disabled={!selectedAgentId || loading}
                    >
                        {loading ? 'Assigning...' : 'Assign Agent'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AgentAssignModal;
